import { render, staticRenderFns } from "./ReplaceDocument.vue?vue&type=template&id=4914dc65&"
import script from "./ReplaceDocument.vue?vue&type=script&lang=js&"
export * from "./ReplaceDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports